import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["actions"]

  toggle(event) {
    // Toggle the opacity and translate
    if (this.actionsTarget.classList.contains("opacity-0")) {
      this.actionsTarget.classList.remove("opacity-0", "translate-x-4")
      this.actionsTarget.classList.add("opacity-100", "translate-x-0")
    } else {
      this.actionsTarget.classList.remove("opacity-100", "translate-x-0")
      this.actionsTarget.classList.add("opacity-0", "translate-x-4")
    }
  }
}
